import "./Footer.scss";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube
} from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { getServicesList } from "services/serviceslist/services";

const Footer = () => {
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-");

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await getServicesList({ page: 1, limit: 50 });
        if (res?.code === 200) {
          setServices(res.data.services || []);
        }
      } catch (e) {
        console.error("Footer services load error:", e);
      }
    };

    fetchServices();
  }, []);

  return (
    <footer className="sahyog-footer">
      <div className="footer-container">

        {/* Logo Section */}
        <div className="footer-col logo-col">
          <img src="/assets/icons/sahyognobg.png" alt="Sahyog Care" className="footer-logo" />
          <h2>SAHYOG</h2>
          <p className="tagline">Care Home & Health Services</p>
          <p className="hindi">सहयोग केअर होम एंड हेल्थ सर्विसेज</p>
          <p className="desc">
            Trusted home healthcare partner for thousands of families across India.
          </p>
        </div>

        {/* DYNAMIC SERVICES FROM API */}
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            {services.length > 0 ? (
              services.slice(0, 6).map((srv) => (
                <li key={srv.id}>
                  <button
                    className="footer-service-link"
                    onClick={() => navigate(`/service/${slugify(srv.title)}`)}
                  >
                    {srv.title}
                  </button>
                </li>
              ))
            ) : (
              <>
                <li>Loading...</li>
              </>
            )}
          </ul>
        </div>

        {/* Company */}
        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><Link to="#">Careers</Link></li>
            <li><Link to="/contactus">Contact Us</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
          </ul>
        </div>

        {/* Contacts + Social Icons */}
        <div className="footer-col contact-col">
          <h4>24×7 Support</h4>

          <div className="contact-info">
            <div className="contact-item">
              <FiPhoneCall className="icon" />
              <div>
                <a href="tel:+918291008181">+91 8291008181</a>
                <small>Call Anytime</small>
              </div>
            </div>

            <div className="contact-item">
              <FaWhatsapp className="icon whatsapp" />
              <div>
                <a href="https://wa.me/918291008181" target="_blank" rel="noreferrer">
                  WhatsApp
                </a>
                <small>Instant Response</small>
              </div>
            </div>

            <div className="contact-item">
              <FaEnvelope className="icon" />
              <a href="mailto:care@sahyogcare.in">care@sahyogcare.in</a>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt className="icon" />
              <span>Mumbai</span>
            </div>
          </div>

          {/* SOCIAL ICONS — back exactly like you want */}
          <div className="social-links">
            <a href="#" aria-label="Instagram"><FaInstagram /></a>
            <a href="#" aria-label="Facebook"><FaFacebookF /></a>
            <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#" aria-label="YouTube"><FaYoutube /></a>
            <a href="https://wa.me/918291008181" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>

          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 SAHYOG Care Home & Health Services Pvt Ltd. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
